import { GET_THEME } from "./actions";

export default function (state = {}, action) {
  switch (action.type) {
    case GET_THEME:
      return { ...state, ...action.payload, fetched: true };
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/theme/index.js